import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {InputText} from "primereact/inputtext";
import PreCadastro from "../model/PreCadastro";
import TipoRestaurante from "../model/TipoRestaurante";
import {DiaFuncionamento} from "../model/DiaFuncionamento";
import axios from "axios";
import rest from "../utils/EnvConfig";
import {ProgressBar} from "primereact/progressbar";
import {Tag} from "primereact/tag";
import {Button} from "primereact/button";
import {InputMask} from "primereact/inputmask";
import {Dropdown} from "primereact/dropdown";
import {Tooltip} from "primereact/tooltip";
import {FileUpload} from "primereact/fileupload";
import CpfCnpjUtils from "../utils/CpfCnpjUtils";
import TelefoneUtils from "../utils/TelefoneUtils";
import CpfCnpj from "./cpfcnpj/CpfCnpj";
import {Checkbox} from "primereact/checkbox";
import EmailUtils from "../utils/EmailUtils";
import $ from 'jquery';
import HorarioUtils from "../utils/HorarioUtils";
import {Dialog} from "primereact/dialog";
import TelefoneBR from "./telefoneBR/TelefoneBR";
import {Toast} from "primereact/toast";
import StepCadastroFinalizado from "./StepCadastroFinalizado";

const StepperComponent = () => {
    const [currentStep, setCurrentStep] = useState(1);
    const totalSteps: number = 8;
    const [preCadastro, setPreCadastro] = useState<PreCadastro>(new PreCadastro());
    const [aceiteTermos, setAceiteTermos] = useState<boolean>(false);
    const [cadastroFinalizado, setCadastroFinalizado] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [limpouSeguranca, setLimpouSeguranca] = useState<boolean>(false);
    const [exibirPoliticas, setExibirPoliticas] = useState<boolean>(false);
    const [passarSemEndereco, setPassarSemEndereco] = useState<boolean>(false);
    const [limpouEstabelecimento, setLimpouEstabelecimento] = useState<boolean>(false);
    const [tiposRestaurante, setTiposRestaurante] = useState<TipoRestaurante[]>();
    const toast = useRef<any>(null);
    const [totalSize, setTotalSize] = useState(0);
    const fileUploadRef = useRef<any>(null);
    const atendimento: string[] = ["Presencial", "Delivery"];
    const diasFuncionamento: DiaFuncionamento[] = [
        DiaFuncionamento.SEGUNDA_SABADO,
        DiaFuncionamento.SEGUNDA_SEXTA,
        DiaFuncionamento.TERCA_DOMINGO,
        DiaFuncionamento.NAO_DEFINIR,
    ];
    const styles = {
        container: {
            maxWidth: '800px',
            margin: '0 auto',
            padding: '24px',
            backgroundColor: 'white',
            boxShadow: 'rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px'
        },
        progressContainer: {
            marginBottom: '24px'
        },
        progressBar: {
            backgroundColor: '#e5e7eb',
            borderRadius: '9999px',
            height: '8px',
            marginBottom: '8px'
        },
        progressFill: {
            backgroundColor: '#f59e0b',
            height: '8px',
            borderRadius: '9999px',
            transition: 'width 0.3s ease'
        },
        progressText: {
            textAlign: 'right',
            fontSize: '14px',
            color: '#6b7280'
        },
        formContainer: {
            backgroundColor: 'white',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            padding: '24px',
            marginBottom: '24px',
            minHeight: '400px'
        },
        formTitle: {
            fontSize: '24px',
            fontWeight: '600',
            marginBottom: '16px',
            color: '#374151'
        },
        formGroup: {
            marginBottom: '16px'
        },
        label: {
            display: 'block',
            fontSize: '14px',
            fontWeight: '500',
            marginBottom: '4px',
            color: '#374151'
        },
        input: {
            width: '100%',
            padding: '8px 12px',
            border: '1px solid #d1d5db',
            borderRadius: '4px',
            fontSize: '16px',
            // boxSizing: 'border-box'
        },
        password: {
            width: '100%',
            // padding: '8px 12px',
            // border: '1px solid #d1d5db',
            // borderRadius: '4px',
            fontSize: '16px',
            // boxSizing: 'border-box'
        },
        select: {
            width: '100%',
            // padding: '8px 12px',
            // border: '1px solid #d1d5db',
            // borderRadius: '4px',
            fontSize: '16px',
            // boxSizing: 'border-box'
        },
        gridTwo: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '12px'
        },
        gridTwoEndereco: {
            display: 'grid',
            gridTemplateColumns: '1fr 0.75fr',
            gap: '12px'
        },
        buttonContainer: {
            display: 'flex',
            justifyContent: 'space-between'
        },
        buttonSecondary: {
            padding: '12px 24px',
            backgroundColor: '#e5e7eb',
            color: '#374151',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px',
            transition: 'background-color 0.2s'
        },
        buttonPrimary: {
            padding: '12px 24px',
            backgroundColor: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px',
            transition: 'background-color 0.2s'
        },
        buttonDisabled: {
            opacity: '0.5',
            cursor: 'not-allowed'
        },
        linkPrimary: {
            color: '#374151',
        },
        reviewContainer: {
            backgroundColor: '#f9fafb',
            padding: '16px',
            borderRadius: '8px'
        },
        reviewSection: {
            borderBottom: '1px solid #e5e7eb',
            paddingBottom: '8px',
            marginBottom: '12px'
        },
        reviewTitle: {
            fontWeight: '500',
            color: '#374151',
            marginBottom: '4px'
        },
        reviewText: {
            fontSize: '14px',
            color: '#6b7280'
        },
        successBox: {
            backgroundColor: '#ecfdf5',
            border: '1px solid #bbf7d0',
            padding: '12px',
            borderRadius: '4px',
            marginTop: '16px'
        },
        successText: {
            fontSize: '14px',
            color: '#065f46'
        }
    };

    useEffect(() => {
        axios.get(`${rest.server}precadastro/tiposrestaurante`)
            .then(response => {
                setTiposRestaurante(response.data);
            })
            .catch(error => console.error(error))
    }, []);


    const handleInputChange = useCallback((field: any, value: any) => {
        setPreCadastro(prev => ({
            ...prev,
            [field]: value
        }));
    }, []);

    const onTemplateSelect = (e: any) => {
        let _totalSize = totalSize;
        let files = e.files;

        Object.keys(files).forEach((key) => {
            _totalSize += files[key].size || 0;
        });

        setTotalSize(_totalSize);
    };

    const onTemplateUpload = (e: any) => {
        const response: any = JSON.parse(e.xhr.response);
        let _totalSize = 0;


        e.files.forEach((file: any) => {
            _totalSize += file.size || 0;
        });

        setTotalSize(_totalSize);
        setPreCadastro({...preCadastro, logo: response.imagem});
        toast.current.show({ severity: 'info', summary: 'Sucesso', detail: 'Arquivo enviado' });
    };

    const onTemplateRemove = (file: any, callback: any) => {
        setTotalSize(totalSize - file.size);
        callback();
    };

    const onTemplateClear = () => {
        setTotalSize(0);
    };

    const headerTemplate = (options: any) => {
        const { className, chooseButton, uploadButton, cancelButton } = options;
        const value = totalSize / 10000;
        const formatedValue = fileUploadRef && fileUploadRef.current ? fileUploadRef.current.formatSize(totalSize) : '0 B';

        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                {uploadButton}
                {cancelButton}
                <div className="flex align-items-center gap-3 ml-auto">
                    <span>{formatedValue} / 1 MB</span>
                    <ProgressBar value={value} showValue={false} style={{ width: '10rem', height: '12px' }}></ProgressBar>
                </div>
            </div>
        );
    };

    const itemTemplate = (file: any, props: any) => {
        return (
            <div className="flex align-items-center flex-wrap">
                <div className="flex align-items-center" style={{ width: '40%' }}>
                    <img alt={file.name} role="presentation" src={file.objectURL} width={100} />
                    {/*<span className="flex flex-column text-left ml-2">*/}
                    {/*    {file.name}*/}
                    {/*</span>*/}
                </div>
                <Tag value={props.formatSize} severity="warning" className="px-3 py-2" />
                <Button type="button" icon="pi pi-times" className="p-button-outlined p-button-rounded p-button-danger ml-auto"
                        onClick={() => onTemplateRemove(file, props.onRemove)} />
            </div>
        );
    };

    const emptyTemplate = () => {
        return (
            <div className="flex align-items-center flex-column">
                <i className="pi pi-image p-3" style={{ fontSize: '4em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                <span style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)' }} className="my-1">

                </span>
            </div>
        );
    };

    const chooseOptions = { icon: 'pi pi-fw pi-upload', iconOnly: true, className: 'custom-choose-btn p-button-rounded p-button-outlined' };
    const uploadOptions = { icon: 'pi pi-fw pi-cloud-upload', iconOnly: true, className: 'custom-upload-btn p-button-success p-button-rounded p-button-outlined' };
    const cancelOptions = { icon: 'pi pi-fw pi-times', iconOnly: true, className: 'custom-cancel-btn p-button-danger p-button-rounded p-button-outlined' };

    const onDadosPessoais = async () => {
        if (!preCadastro.email) {
            alert("E-mail é obrigatório");
            return;
        }

        if (!EmailUtils.isEmail(preCadastro.email)) {
            alert("E-mail é inválido");
            return;
        }

        if (!preCadastro.nome) {
            alert("Nome é obrigatório");
            return;
        }

        if (!preCadastro.cpf) {
            alert("CPF é obrigatório");
            return;
        }

        if (!CpfCnpjUtils.isCpfCnpj(preCadastro.cpf)) {
            alert("CPF é inválido");
            return;
        }

        if (!preCadastro.telefone) {
            alert("Telefone é obrigatório");
            return;
        }

        if (!TelefoneUtils.isTelefone(preCadastro.telefone)) {
            alert("Telefone é inválido");
            return;
        }

        setLoading(true);
        axios.post(`${rest.server}precadastro/verificar/usuario`, preCadastro)
            .then(response => {
                setPreCadastro({...preCadastro, jaExisteUsuario: response.data.jaExisteUsuario})
                setCurrentStep(currentStep + 1);
            })
            .catch(error => alert(error.response.data))
            .finally(() => setLoading(false));
    };

    const onSeguranca = async () => {
        if (!preCadastro.jaExisteUsuario) {
            if (!preCadastro.senha) {
                alert("Informe uma senha para seu usuário");
                return;
            }

            if (!preCadastro.confirmarSenha) {
                alert("Informe a confirmação da senha");
                return;
            }

            if (preCadastro.senha !== preCadastro.confirmarSenha) {
                alert("As senhas não são iguais");
                return;
            }

            setCurrentStep(currentStep + 1);
            return;
        }

        axios.post(`${rest.server}precadastro/autenticar/usuario`, preCadastro)
            .then(response => {
                setCurrentStep(currentStep + 1);
            })
            .catch(error => alert(error.response.data))
            .finally(() => setLoading(false));
    };

    const onEstabelecimento = async () => {
        if (!preCadastro.nomeEstabelecimento) {
            alert("Informe o nome do seu estabelecimento");
            return;
        }

        if (!preCadastro.cnpjCpfEstabelecimento) {
            alert("Informe CPF/CNPJ do seu estabelecimento");
            return;
        }

        if (!CpfCnpjUtils.isCpfCnpj(preCadastro.cnpjCpfEstabelecimento)) {
            alert("CPF/CNPJ é inválido");
            return;
        }

        setCurrentStep(currentStep + 1);
    };

    const onLocalizacao = async () => {
        if (!preCadastro.cep) {
            alert("Informe o CEP para localizarmos seu endereço");
            return;
        }

        if (!preCadastro.numeroEstabelecimento) {
            alert("Informe o número do estabelecimento para localizarmos seu endereço");
            return;
        }

        setLoading(true);
        axios.post(`${rest.server}precadastro/obter/localizacao`, preCadastro)
            .then(response => {
                setPreCadastro(response.data);
            })
            .catch(error => {
                setPassarSemEndereco(true);
                alert(error.response.data);
            })
            .finally(() => setLoading(false));
    };

    const onContinuarSemEndereco = () => {
        if (!preCadastro.cep) {
            alert("Informe o CEP");
            return;
        }

        if (!preCadastro.numeroEstabelecimento) {
            alert("Informe o número do estabelecimento");
            return;
        }

        nextStep();
    }

    const onDigitarCep = (e: any) => {
        setPreCadastro({...preCadastro,
            cep: e.target.value, enderecoCompleto: undefined, latitude: undefined, longitude: undefined});
    }

    const onDigitarNumero = (e: any) => {
        setPreCadastro({
            ...preCadastro,
            numeroEstabelecimento: e.target.value,
            enderecoCompleto: undefined,
            latitude: undefined,
            longitude: undefined
        });
    }

    const onDadosFuncionais = async () => {
        if (!preCadastro.tipoRestaurante) {
            alert("Informe a categoria principal do seu estabelecimento");
            return;
        }

        if (!preCadastro.atendimento) {
            alert("Informe o tipo de atendimento do seu estabelecimento");
            return;
        }

        if (!preCadastro.diaFuncionamento) {
            alert("Escolha uma das opções de dias de funcionamento");
            return;
        }

        if (!preCadastro.abertura) {
            alert("Informe a hora de abertura do seu estabelecimento");
            return;
        }

        if (!preCadastro.fechamento) {
            alert("Informe a hora do fechamento do seu estabelecimento");
            return;
        }

        if (!HorarioUtils.isHoraValida(preCadastro.abertura)) {
            alert("O horário de abertura não é uma hora válida");
            return;
        }

        if (!HorarioUtils.isHoraValida(preCadastro.fechamento)) {
            alert("O horário de fechamento não é uma hora válida");
            return;
        }

        if (!HorarioUtils.isHoraFinalMaior(preCadastro.abertura, preCadastro.fechamento)) {
            alert("O horário de fechamento deve ser maior que o horário de abertura");
            return;
        }

        setCurrentStep(currentStep + 1);
    };

    const onLogo = async () => {
        setCurrentStep(currentStep + 1);
    };

    const onFinalizar = async () => {
        if (!aceiteTermos) {
            alert("Por favor, leia os termos e aceite antes de finalizar.");
            return;
        }

        setLoading(true);
        axios.post(`${rest.server}precadastro/finalizar/cadastro`, preCadastro)
            .then(response => {
                alert("Cadastro efetuado com sucesso");
                setCadastroFinalizado(true);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
                alert(error.response.data);
        });
    };

    const nextStep = async () => {
        if (currentStep <= totalSteps) {
            if (currentStep === 1) {
                setCurrentStep(currentStep + 1);
            } else if (currentStep === 2) {
                await onDadosPessoais();
            } else if (currentStep === 3) {
                await onSeguranca();
            } else if (currentStep === 4) {
                await onEstabelecimento();
            } else if (currentStep === 5) {
                setCurrentStep(currentStep + 1);
            } else if (currentStep === 6) {
                await onDadosFuncionais();
            } else if (currentStep === 7) {
                await onLogo();
            } else if (currentStep === 8) {
                await onFinalizar();
            }
        }
    };

    const prevStep = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    };

    const StepBemVindo = () => (
        <div>
            <h3 style={styles.formTitle}>Bem-vindo</h3>
            <div>
                Você está fazendo um cadastro de usuário. <br/><br/>Ele é necessário para cadastrar um
                estabelecimento.
            </div>
        </div>
    );

    const stepDadosPessoais = useMemo(() => (
        <div>
            <h3 style={styles.formTitle}>Dados pessoais</h3>
            <div>
                <div style={styles.formGroup}>
                    <label style={styles.label}>E-mail</label>
                    <InputText type="email"
                               value={preCadastro.email}
                               onChange={(e) => handleInputChange('email', e.target.value)}
                               style={styles.input}
                    />
                </div>
                <div style={styles.formGroup}>
                    <label style={styles.label}>Nome</label>
                    <InputText id="nome" type="text"
                               value={preCadastro.nome}
                               onChange={(e) => handleInputChange('nome', e.target.value)}
                               style={styles.input}/>
                </div>
                <div style={styles.formGroup}>
                    <label style={styles.label}>CPF</label>
                    <InputMask id="cpf" mask="999.999.999-99" placeholder=""
                               value={preCadastro.cpf}
                               onChange={(e) => handleInputChange('cpf', e.value)}
                               style={styles.input}/>
                </div>
                <div style={styles.formGroup}>
                    <label style={styles.label}>Telefone (WhatsApp)</label>
                    <TelefoneBR id={"whatsapp"}
                                value={preCadastro.telefone}
                                style={styles.input}
                                onChangeHandler={(e) => handleInputChange('telefone', e)} />
                </div>
            </div>
        </div>
    ), [preCadastro.email, preCadastro.nome, preCadastro.cpf, preCadastro.telefone,
                handleInputChange,
                styles.formTitle,
                styles.formGroup,
                styles.label, styles.input]);

    const stepSeguranca = useMemo(() => (
        <div>
            {!preCadastro.jaExisteUsuario && (
                <>
                    <h3 style={styles.formTitle}>Segurança</h3>
                    <div>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Senha</label>
                            <InputText id="senha"
                                       type={"password"}
                                       value={preCadastro.senha}
                                       onChange={(e) => handleInputChange('senha', e.target.value)}
                                       style={styles.input}/>
                        </div>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Confirmar senha</label>
                            <InputText id="confirmarSenha"
                                       type={"password"}
                                       value={preCadastro.confirmarSenha}
                                       onChange={(e) => handleInputChange('confirmarSenha', e.target.value)}
                                       style={styles.input}/>
                        </div>
                    </div>
                </>
            )}

            {preCadastro.jaExisteUsuario && (
                <>
                    <h3 style={styles.formTitle}>Autenticação</h3>
                    <div>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>E-mail</label>
                            <InputText type="email"
                                       value={preCadastro.email}
                                       onChange={(e) => handleInputChange('email', e.target.value)}
                                       style={styles.input}
                            />
                        </div>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Senha</label>
                            <InputText id="senha"
                                       type={"password"}
                                       value={preCadastro.senha}
                                       onChange={(e) => handleInputChange('senha', e.target.value)}
                                       style={styles.input}/>
                        </div>
                    </div>
                </>
            )}
        </div>
    ), [preCadastro.email,
                preCadastro.jaExisteUsuario,
                preCadastro.senha, preCadastro.confirmarSenha,
                handleInputChange,
                styles.formTitle,
                styles.input,
                styles.formGroup,
                styles.label]);

    const stepEstabelecimento = useMemo(() => (
        <div>
            <h3 style={styles.formTitle}>Estabelecimento</h3>
            <div>
                <div style={styles.formGroup}>
                    <label style={styles.label}>Nome do estabelecimento</label>
                    <InputText id="nomeEstabelecimento"
                               value={preCadastro.nomeEstabelecimento}
                               onChange={(e) => handleInputChange('nomeEstabelecimento', e.target.value)}
                               style={styles.input}/>
                </div>
                <div style={styles.formGroup}>
                    <label style={styles.label}>CNPJ / CPF</label>
                    <CpfCnpj id="cpfCnpj"
                             placeholder={"Somente números"}
                             value={preCadastro.cnpjCpfEstabelecimento}
                             onChangeHandler={(e: any) => handleInputChange('cnpjCpfEstabelecimento', e.target.value)}
                             style={styles.input} />
                </div>
            </div>
        </div>
    ), [preCadastro.nomeEstabelecimento, preCadastro.cnpjCpfEstabelecimento,
                handleInputChange,
                styles.formTitle,
                styles.formGroup,
                styles.label]);

    const stepLocalizacao = useMemo(() => (
        <div>
            <h3 style={styles.formTitle}>Localização</h3>
            <h4>Digite seu CEP e o número do estabelecimento</h4>
            <div>
                <div style={styles.gridTwo}>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>CEP</label>
                        <InputMask id="cep" mask="99999-999" placeholder=""
                                   value={preCadastro.cep}
                                   onChange={onDigitarCep}
                                   style={styles.input}/>
                    </div>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Número</label>
                        <InputText id="numeroEstabelecimento" placeholder="" keyfilter={"pint"}
                                   value={preCadastro.numeroEstabelecimento}
                                   onChange={onDigitarNumero}
                                   style={styles.input}
                        />
                    </div>
                </div>
                <div className="field">
                    {preCadastro.enderecoCompleto && preCadastro.enderecoCompleto !== "Brasil" &&
                        <>
                            <b>Seu endereço está correto? Você pode alterar depois no painel.</b>
                            <br/>
                            <br/>
                            {preCadastro.enderecoCompleto.replace(/, Brasil/g, "")}
                        </>
                    }
                </div>
            </div>
        </div>
    ), [preCadastro.cep, preCadastro.numeroEstabelecimento, preCadastro.enderecoCompleto,
        handleInputChange,
        styles.formTitle,
        styles.gridTwo,
        styles.formGroup,
        styles.label]);

    const stepDadosFuncionais = useMemo(() => (
        <div>
            <h3 style={styles.formTitle}>Dados funcionais</h3>
            <div>
                <div style={styles.formGroup}>
                    <label style={styles.label}>Categoria principal</label>
                    <Dropdown id="categoriaPrincipal" placeholder=""
                              options={tiposRestaurante} value={preCadastro.tipoRestaurante}
                              optionLabel="nomeAtividade"
                              onChange={(e) => handleInputChange('tipoRestaurante', e.value)}
                              style={styles.select}/>
                </div>
                <div style={styles.formGroup}>
                    <label style={styles.label}>Atendimento</label>
                    <Dropdown id="atendimento" placeholder=""
                              options={atendimento} value={preCadastro.atendimento}
                              onChange={(e) => handleInputChange('atendimento', e.value)}
                              style={styles.select}/>
                </div>
                <div style={styles.formGroup}>
                    <label style={styles.label}>Dias de funcionamento</label>
                    <Dropdown id="diasFuncionamento" placeholder=""
                              options={diasFuncionamento} value={preCadastro.diaFuncionamento}
                              onChange={(e) => handleInputChange('diaFuncionamento', e.value)}
                              style={styles.select}/>
                </div>
                <div style={styles.gridTwo}>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Abertura</label>
                        <InputMask id="abertura" mask="99:99" placeholder=""
                                   value={preCadastro.abertura}
                                   onChange={(e) => handleInputChange('abertura', e.value)}
                                   style={styles.input}/>
                    </div>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Fechamento</label>
                        <InputMask id="fechamento" mask="99:99" placeholder=""
                                   value={preCadastro.fechamento}
                                   onChange={(e) => handleInputChange('fechamento', e.value)}
                                   style={styles.input}/>
                    </div>
                </div>
            </div>
        </div>
    ), [atendimento, diasFuncionamento, tiposRestaurante,
                preCadastro.tipoRestaurante, preCadastro.atendimento,
                preCadastro.diaFuncionamento, preCadastro.abertura,
                preCadastro.fechamento,
                handleInputChange,
                styles.formTitle,
                styles.gridTwo,
                styles.formGroup,
                styles.label]);

    const stepLogo = useMemo(() => (
        <div>
            <h3 style={styles.formTitle}>Logo</h3>
            <div>
                <Tooltip target=".custom-choose-btn" content="Escolher um arquivo" position="bottom" />
                <Tooltip target=".custom-cancel-btn" content="Limpar" position="bottom" />

                <FileUpload ref={fileUploadRef} name="logo" url={`${rest.server}precadastro/upload`} accept="image/*" maxFileSize={5242880}
                            auto={true} multiple={false}
                            onUpload={onTemplateUpload} onSelect={onTemplateSelect} onError={onTemplateClear} onClear={onTemplateClear}
                            headerTemplate={headerTemplate} itemTemplate={itemTemplate} emptyTemplate={emptyTemplate}
                            chooseOptions={chooseOptions} uploadOptions={uploadOptions} cancelOptions={cancelOptions} />
            </div>
        </div>
    ), [onTemplateUpload, onTemplateSelect, onTemplateClear, headerTemplate, itemTemplate, emptyTemplate,
                chooseOptions, uploadOptions, cancelOptions, styles.formTitle
    ]);

    const StepResumo = () => (
        <div>
            <h3 style={styles.formTitle}>Confirmação dos dados</h3>
            <div style={styles.reviewContainer}>
                <div style={styles.reviewSection}>
                    <h4 style={styles.reviewTitle}>Dados Básicos</h4>
                    <p style={styles.reviewText}>{preCadastro.nome} - {preCadastro.cnpjCpfEstabelecimento}</p>
                </div>
                <div style={styles.reviewSection}>
                    <h4 style={styles.reviewTitle}>Endereço</h4>
                    <p style={styles.reviewText}>{preCadastro.enderecoCompleto?.replace(/, Brasil/g, "")}</p>
                </div>
                <div>
                    <h4 style={styles.reviewTitle}>Atendimento</h4>
                    <p style={styles.reviewText}>{preCadastro.nomeEstabelecimento}</p>
                    <p style={styles.reviewText}>{preCadastro.tipoRestaurante?.nomeAtividade} - {preCadastro.atendimento}</p>
                    <p style={styles.reviewText}>{preCadastro.diaFuncionamento} - {preCadastro.abertura} às {preCadastro.fechamento}</p>
                </div>
            </div>
            <div style={styles.successBox}>
                <p style={styles.successText}>
                    ✓ Revise os dados acima e clique em "Concluir" para completar seu cadastro.
                </p>
            </div>

            <p>
                <Button label="Clique aqui para ler os termos" link
                        style={styles.linkPrimary}
                        onClick={() => setExibirPoliticas(true)}/>
            </p>

            <p>
                <div className="flex align-items-center">
                    <Checkbox inputId="termos"
                              onChange={e => setAceiteTermos(e.checked ?? false)}
                              checked={aceiteTermos}/>
                    <label htmlFor="termos" className="ml-2">Li e aceito os termos.</label>
                </div>
            </p>
        </div>
    );

    const renderCurrentStep = () => {
        switch (currentStep) {
            case 1:
                return <StepBemVindo/>;
            case 2:
                return stepDadosPessoais;
            case 3:
                if (!limpouSeguranca) {
                    setTimeout(() => {
                        $('#senha').val('');
                        $('#confirmarSenha').val('');
                        setLimpouSeguranca(true);
                    }, 1);
                }
                return stepSeguranca;
            case 4:
                if (!limpouEstabelecimento) {
                    setTimeout(() => {
                        $('#nomeEstabelecimento').val('');
                        setLimpouEstabelecimento(true);
                    }, 1);
                }
                return stepEstabelecimento;
            case 5:
                return stepLocalizacao;
            case 6:
                return stepDadosFuncionais;
            case 7:
                return stepLogo;
            case 8:
                return <StepResumo/>;
            default:
                return <StepBemVindo/>;
        }
    };



    const decidirComportamentoEndereco = () => {
        if (!passarSemEndereco) {
            return <Button label={"Validar endereço"} iconPos="right"
                           severity={"success"}
                           onClick={onLocalizacao}
                           loading={loading}/>;
        }

        return  <div>
                    <div style={styles.gridTwoEndereco}>
                        <div style={styles.formGroup}>
                            <Button label={"Continuar sem endereço"} iconPos="right"
                                severity={"warning"}
                                onClick={onContinuarSemEndereco}
                                loading={loading}/>
                        </div>
                        <div style={styles.formGroup}>
                            <Button label={"Validar endereço"} iconPos="right"
                               severity={"success"}
                               onClick={onLocalizacao}
                               loading={loading} />
                        </div>
                    </div>
                </div>;
    };

    return (
        <div style={styles.container}>
            <Toast ref={toast} />

            {!cadastroFinalizado &&
                <div style={styles.progressContainer}>
                    <div style={styles.progressBar}>
                        <div
                            style={{
                                ...styles.progressFill,
                                width: `${(currentStep / totalSteps) * 100}%`
                            }}
                        ></div>
                    </div>
                    <div style={{
                        textAlign: 'right',
                        fontSize: '14px',
                        color: '#6b7280'}}>
                        <span>{currentStep} de {totalSteps}</span>
                    </div>
                </div>
            }

            <div style={styles.formContainer}>
                {cadastroFinalizado ? (
                    <StepCadastroFinalizado linkAndroid={rest.linkAndroid} linkIos={rest.linkIos}/>
                ) : (
                    renderCurrentStep()
                )}
            </div>

            {!cadastroFinalizado &&
                <div style={styles.buttonContainer}>
                    <Button label="Voltar" severity="secondary" icon="pi pi-arrow-left"
                            style={{
                                ...(currentStep === 1 ? styles.buttonDisabled : {}),
                                height: "46px"
                            }}
                            onClick={prevStep}
                            disabled={currentStep === 1} />

                    {currentStep === 5 && !preCadastro.enderecoCompleto ? (
                        decidirComportamentoEndereco()
                    ) : (
                        <Button label={currentStep === totalSteps ? "Concluir" : "Continuar →"} iconPos="right"
                                onClick={nextStep}
                                loading={loading} />
                    )}
                </div>
            }

            <Dialog header={"Nossas Políticas"} visible={exibirPoliticas}
                    style={{ width: '50vw' }} onHide={() => {if (!exibirPoliticas) return; setExibirPoliticas(false); }}>
                <h2>Nossas Políticas</h2>

                <p>
                    No "OQ abre hoje", sua privacidade é nossa prioridade. Coletamos e utilizamos apenas os dados necessários
                    para melhorar sua experiência no aplicativo, garantindo transparência e segurança no tratamento das suas informações.
                    Abaixo, explicamos como isso funciona:
                </p>

                <p>
                    1. Dados Coletados<br/>
                    Coletamos os seguintes tipos de dados:
                    Informações de cadastro: como nome, e-mail e telefone.
                    Localização: para conectar você a estabelecimentos e serviços próximos.
                    Preferências: para personalizar recomendações e melhorar sua experiência.
                </p>

                <p>
                    2. Finalidades do Uso dos Dados<br/>
                    Utilizamos seus dados para:
                    Conectar você a estabelecimentos e serviços disponíveis.
                    Personalizar recomendações com base nas suas preferências.
                    Enviar comunicações de marketing, como promoções e novidades (sempre com a opção de cancelamento).
                    Cumprir obrigações legais e regulatórias.
                    Garantir o funcionamento adequado do aplicativo.
                </p>

                <p>
                    3. Compartilhamento de Dados<br/>
                    Com terceiros: Não compartilhamos suas informações pessoais sem sua autorização, exceto quando
                    exigido por lei.
                    Parceiros e estabelecimentos: Podemos compartilhar dados anônimos ou agregados para fins de análise
                    e melhoria de serviços.
                </p>

                <p>
                    4. Segurança dos Dados<br/>
                    Adotamos medidas técnicas e organizacionais para proteger suas informações contra acesso não
                    autorizado,
                    alteração, divulgação ou destruição. No entanto, nenhum sistema é 100% seguro, e não podemos
                    garantir segurança absoluta.
                </p>

                <p>
                    5. Seus Direitos<br/>
                    Você tem o direito de:
                    Acessar, corrigir ou excluir seus dados pessoais.
                    Revogar consentimentos previamente concedidos.
                    Opor-se ao uso de suas informações para fins de marketing.
                    Para exercer esses direitos, entre em contato conosco pelo e-mail: contato@oqabrehoje.com.br.
                </p>

                <p>
                    6. Conteúdo de Terceiros<br/>
                    O aplicativo contém informações fornecidas por estabelecimentos e serviços de terceiros, como
                    horários de funcionamento,
                    valores, medidas, localização, imagens e descrições. Não nos responsabilizamos pela precisão ou
                    práticas desses terceiros.
                </p>

                <p>
                    7. Consentimento<br/>
                    Ao usar o aplicativo, você concorda com esta política. Recomendamos que você a leia atentamente e a
                    revise periodicamente para estar ciente de possíveis atualizações.
                </p>

                <h2>
                    Termos de Uso
                </h2>

                <p>
                    Ao utilizar o aplicativo "OQ abre hoje", você concorda com os seguintes termos:
                </p>

                <p>
                    1. Uso do<br/>
                    Proibições: Não copie, modifique, distribua ou utilize indevidamente o conteúdo do aplicativo sem
                    autorização prévia.
                    Responsabilidade: O uso do aplicativo é de sua responsabilidade. Não nos responsabilizamos por
                    eventuais danos ou
                    prejuízos decorrentes do uso inadequado
                </p>

                <p>
                    2. Conteúdo de Terceiros<br/>
                    O aplicativo exibe informações de estabelecimentos e serviços de terceiros. Não nos
                    responsabilizamos pela precisão,
                    atualidade ou práticas desses conteúdos.
                    Recomendamos que você verifique diretamente com o estabelecimento ou serviço as informações
                    fornecidas.
                </p>

                <p>
                    3. Privacidade<br/>
                    Respeitamos sua privacidade e seguimos rigorosamente a Lei Geral de Proteção de Dados (LGPD). Para
                    mais detalhes,
                    consulte nossa Política de Privacidade.
                </p>

                <p>
                    4. Cookies e Tecnologias Similares<br/>
                    Utilizamos cookies e tecnologias similares para melhorar sua experiência no aplicativo.
                    Você pode desativar os cookies nas configurações do seu navegador, mas isso pode limitar algumas funcionalidades.
                </p>

                <p>
                    5. Links Externos<br/>
                    O aplicativo pode conter links para sites ou serviços de terceiros. Não controlamos ou nos
                    responsabilizamos pelo conteúdo,
                    políticas de privacidade ou práticas desses sites.
                </p>

                <p>
                    6. Alterações nos Termos<br/>
                    Reservamo-nos o direito de atualizar estes termos periodicamente. Recomendamos que você revise esta
                    página regularmente
                    para estar ciente de quaisquer mudanças.
                    Alterações significativas serão comunicadas por e-mail ou por meio de notificações no aplicativo.
                </p>

                <p>
                    7. Contato<br/>
                    Em caso de dúvidas, sugestões ou para exercer seus direitos relacionados à privacidade,
                    entre em contato conosco pelo e-mail: contato@oqabrehoje.com.br.
                </p>
            </Dialog>
        </div>
    );
};

export default StepperComponent;